import { useEffect, useState } from "react";
import Container from "../../../utils/Container";
import { IoIosArrowForward } from "react-icons/io";
import { viewSingleBlog } from "../../../api/website/blog/blogApi";
import { Link, useParams } from "react-router";
import useSEO from "../../../utils/seo";
import { relatedBlogs } from "../../../api/admin/blogApi";
const Blog = () => {
  const { id } = useParams();
  const [FormData, setFormData] = useState({
    id: "",
    blogTitle: "",
    body: "",
    featuredImage: "",
    categoryId: "",
    tags: [],
    status: "Draft",
    created_by: "",
    createdAt: new Date().toISOString(),
  });
  const [RelatedBlogData, setRelatedBlogData] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      viewSingleBlog(id, setFormData);
    }, 500);
    setTimeout(() => {
      relatedBlogs(setRelatedBlogData, FormData.categoryId);
    }, 1000);
  }, [id, FormData.categoryId]);
  const tags = FormData.tags.join(", ");
  useSEO({
    title: `${FormData.blogTitle || ""} | Dhroobin.com`,
    description: "Welcome to my SEO-optimized React website!",
    image: FormData.featuredImage || "https://example.com/og-home.jpg",
    url: `https://dhoorbin.com/blog/${FormData.id || ""}/${
      FormData.blogTitle || ""
    }`,
    canonical: `https://dhoorbin.com/blog/${FormData.id || ""}/${
      FormData.blogTitle || ""
    }`,
    keywords: tags,
    publisher: "Dhoorbin",
    robots: "index, follow",
    lang: "en",
  });
  console.log(FormData);
  return (
    <Container>
      {FormData.id ? (
        <>
          <div className="space-y-6">
            <div className="relative w-full h-[250px] lg:h-[400px] rounded-xl overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={FormData.featuredImage}
                alt=""
              />
              <div className="p-3 lg:p-10 absolute inset-0 bg-[#0011ff50] backdrop-blur-sm flex justify-center items-center">
                <div className="flex flex-col items-center gap-y-3">
                  <p className="text-2xl text-center text-wrap lg:text-3xl text-white font-bold">
                    {FormData.blogTitle}
                  </p>
                  <div className="flex justify-center items-center gap-x-3">
                    <p className="text-sm bg-[#ff0062f1]  px-2 py-0.5 rounded-md text-white cursor-pointer">
                      {FormData.category_name}{" "}
                    </p>
                    <p className="text-xs text-white">
                      {new Date(FormData.createdAt).toLocaleString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </p>
                  </div>
                  {/* <div className="flex justify-center items-center gap-x-3 py-5">
                    <div className="w-8 lg:w-10 h-8 lg:h-10 rounded-full overflow-hidden">
                      <img
                        className="h-full w-full object-cover"
                        src={FormData.created_by.profilePicture}
                        alt=""
                      />
                    </div>
                    <div>
                      <p className="text-md lg:text-lg font-bold text-white">
                        {DemoData.author.fullname}
                      </p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div>
              <div
                className="text-gray-500 leading-10 text-sm bg-white p-3 lg:p-10 rounded-lg shadow-lg border-1 border-gray-200 border"
                dangerouslySetInnerHTML={{ __html: FormData.body }}
              />
            </div>
            <div className="py-3">
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                {RelatedBlogData ? (
                  <>
                    {RelatedBlogData?.map((item, index) => {
                      return (
                        <div key={index}>
                          <Link to={`/blog/${item.id}/${item.blogTitle}`}>
                            <div className="bg-white shadow-none hover:shadow-lg rounded-md scale-100 hover:scale-105 duration-300 cursor-pointer">
                              <div className="w-full h-auto rounded-md border flex flex-col gap-y-2 p-2">
                                <div className="relative w-full h-50 rounded-md overflow-hidden">
                                  <img
                                    className="w-full h-full object-cover scale-100 hover:scale-105 duration-300"
                                    src={item.featuredImage}
                                    alt=""
                                  />
                                  <div className="absolute top-2 right-2 text-xs bg-[#ff006286] text-white px-2 py-0.5 w-auto h-auto rounded-md cursor-pointer">
                                    {item.category_name}
                                  </div>
                                </div>

                                <div className="space-y-2">
                                  <p className="font-bold text-sm text-[#0d2d63]">
                                    {item.blogTitle}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-xs text-black/80">
                                    {item.body
                                      .replace(/<[^>]+>/g, " ")
                                      .trim()
                                      .split(/\s+/)
                                      .slice(0, 10)
                                      .join(" ") + "..."}
                                  </p>
                                </div>

                                <div className="pt-3 flex justify-between items-center">
                                  <div className="flex items-center justify-start gap-x-1">
                                    <p className="text-xs text-black/80">
                                      {new Date(item.createdAt).toLocaleString(
                                        "en-US",
                                        {
                                          month: "short",
                                          day: "numeric",
                                          year: "numeric",
                                        },
                                      )}
                                    </p>
                                  </div>
                                  <div className="flex items-center gap-x-1 border px-1 py-0.5 rounded-md cursor-pointer  scale-100 hover:scale-105 duration-300">
                                    <div>
                                      <p className="text-xs text-black">
                                        Read Now
                                      </p>
                                    </div>
                                    <div className="text-xs text-black">
                                      <IoIosArrowForward />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="space-y-5">
                    <div className="animate-pulse bg-slate-200 w-36 h-5 rounded-full"></div>
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                      {Array.from({ length: 8 }).map((_, index) => {
                        return (
                          <div
                            key={index}
                            className="animate-pulse bg-slate-200 w-full h-48 rounded-md"
                          ></div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex justify-center items-center animate-pulse bg-slate-200 w-full h-[250px] lg:h-[400px] rounded-xl">
            <div className="flex flex-col items-center gap-y-3">
              <div className="animate-pulse bg-slate-300 w-[200px] lg:w-[400px] h-5"></div>
              <div className="animate-pulse bg-slate-300 w-[100px] lg:w-[200px] h-5"></div>
            </div>
          </div>
          <div className="my-5 animate-pulse bg-slate-200 w-full h-[800px] rounded-xl"></div>
          <div className="space-y-5">
            <div className="animate-pulse bg-slate-200 w-36 h-5 rounded-full"></div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
              {Array.from({ length: 4 }).map((_, index) => {
                return (
                  <div
                    key={index}
                    className="animate-pulse bg-slate-200 w-full h-48 rounded-md"
                  ></div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </Container>
  );
};

export default Blog;
